var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"smTest",class:{ 'hidden': !_vm.smActive, 'show': _vm.smActive },attrs:{"id":"sm-test"}},[_c('div',{class:{ 'hidden': !_vm.areFieldsSet, 'show': _vm.areFieldsSet }},[_c('div',{attrs:{"id":"sm-component"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }